// Backend warning `parameter` payloads are inconsistent: some are a bare JSON array of employee
// IDs (e.g. TINMissing), others wrap it in an object under `EmployeeIDs` (e.g.
// EmployeesSharingTransferDestination) or `employeeIDs` (e.g. MissingDiscoCode). This normalizes
// any of those shapes to a plain string array.
export function parseEmployeeIDs(parameter: string): string[] {
  let parsed: unknown
  try {
    parsed = JSON.parse(parameter)
  } catch {
    return []
  }
  if (Array.isArray(parsed)) {
    return parsed as string[]
  }
  if (parsed && typeof parsed === 'object') {
    const obj = parsed as { EmployeeIDs?: unknown; employeeIDs?: unknown }
    if (Array.isArray(obj.EmployeeIDs)) {
      return obj.EmployeeIDs as string[]
    }
    if (Array.isArray(obj.employeeIDs)) {
      return obj.employeeIDs as string[]
    }
  }
  return []
}
